import axios, { AxiosResponse, AxiosRequestConfig } from 'axios'
import { message } from 'antd'
import { storage } from '@/utils/tools'
import { HOST, AUTH_TOKEN, OSS_UPLOAD_HOST, TUploadCategory } from '@/constants'
import { setUploadData } from './ossUpload'

const $message = message

// 返回数据类型
export interface IResponseData {
  code: number
  data: IAnyObject
  msg: string
}

// httpconfig
interface HttpConfig extends AxiosRequestConfig {
  loading?: boolean
  error?: boolean
}

// UploadConfig
interface UploadConfig extends HttpConfig {
  category: TUploadCategory
}

const TIME_OUT = 60000

const axiosInstance = axios.create({
  baseURL: HOST,
  // baseURL:'http://10.61.15.117:8088/',
  responseType: 'json',
  transformResponse: [
    function(data) {
      return data
    }
  ],
  timeout: TIME_OUT
})

axiosInstance.interceptors.request.use(
  config => {
    config.headers.common['Authorization'] = storage.get(AUTH_TOKEN)
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

axiosInstance.interceptors.response.use(
  (response: AxiosResponse<IResponseData>) => {
    return response
  },
  error => {
    const { response, message } = error
    if (response.status === 401) {
      storage.clear()
      location.href = '/'
    }
    const reason = response ? response.data : { msg: message }
    return Promise.reject(reason)
  }
)

/**
 * http请求
 */
class Http {
  /**
   * 取消
   */
  cancel = axios.CancelToken

  // 初始化请求
  private init(config: HttpConfig): Promise<any> {
    if (config.loading !== false) {
      //
    }
    return new Promise((resolve, reject) => {
      axiosInstance
        .request(config)
        .then(
          (res: AxiosResponse<IResponseData>) => {
            if (
              res.headers['content-type'] &&
              res.headers['content-type'].indexOf('application/json') >= 0
            ) {
              const { code, data, msg } = res.data
              if (code >= 200 && code < 300) {
                resolve(data)
              } else {
                if (config.error !== false) {
                  $message.error(msg)
                }
                reject(msg)
              }
            } else {
              resolve(res)
            }
          },
          err => {
            if (config.error !== false) {
              $message.error(err.msg || '请求失败')
            } else {
              reject(err.msg || '请求失败')
            }
          }
        )
        .finally(() => {})
    })
  }

  /**
   * get请求
   * @param url 请求链接
   * @param config 配置项
   */
  get(url: string, config?: HttpConfig): Promise<any> {
    return this.init(Object.assign({}, { method: 'get', url }, config))
  }

  /**
   * post请求
   * @param url 请求链接
   * @param data 数据
   * @param config 配置项
   */
  post(url: string, data: IAnyObject, config?: HttpConfig): Promise<any> {
    return this.init(Object.assign({}, { method: 'post', url, data }, config))
  }

  /**
   * 上传文件
   * @param file 文件
   * @param category 文件种类(默认为身份证正面, category: '')
   */
  async upload(file: File | Blob, config: UploadConfig): Promise<string> {
    const [fd, key] = await setUploadData(file, config.category)
    const OssUploadHost = storage.get(OSS_UPLOAD_HOST) // 必须放在设置data后面(验证能获取host)
    return new Promise((resolve, reject) => {
      this.post(
        OssUploadHost,
        fd,
        Object.assign(config, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
      )
        .then(
          (res: AxiosResponse<any>) => {
            if (res.status === 200) {
              // OSS上传成功会返回200
              resolve(key)
              $message.success('Upload Success')
            } else {
              reject('Upload Failed!')
            }
          },
          err => {
            reject('Upload Failed!')
          }
        )
        .finally(() => {})
    })
  }
}

export default new Http()
